
import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { LucideIcon } from 'lucide-react';

interface ValueCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  iconClassName: string;
  bgClassName: string;
}

const ValueCard: React.FC<ValueCardProps> = ({ 
  icon: Icon, 
  title, 
  description, 
  iconClassName, 
  bgClassName 
}) => {
  return (
    <Card className="bg-white hover:shadow-md transition-shadow duration-300">
      <CardContent className="pt-6">
        <div className="flex justify-center mb-4">
          <span className={`p-3 rounded-full ${bgClassName}`}>
            <Icon className={`h-6 w-6 ${iconClassName}`} />
          </span>
        </div>
        <h3 className="text-lg font-medium text-gray-900 text-center mb-2">{title}</h3>
        <p className="text-gray-600 text-center">{description}</p>
      </CardContent>
    </Card>
  );
};

export default ValueCard;
